export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q01_b.6e5b88cd.png";